import {advanceDate,validCalendarDate} from "./recurrence.js";
export type FocusOffset="week"|"fortnight"|"month";
/** Shift the selected focus date; an empty field starts at today's calendar date. */
export function shiftFocusDate(value:string,offset:FocusOffset,today:string):string{
 const anchor=validCalendarDate(value)?value:today;
 return advanceDate(anchor,offset==="month"?{unit:"month",interval:1}:{unit:"day",interval:offset==="week"?7:14},1);
}
